import { LoginBackground } from "@/assets/images/login-background";
import { ForgotPasswordForm } from "@/components/pages/forgot-password/forgot-password-form";

export const ForgotPasswordPage = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <LoginBackground />
      <div className="z-10 w-full max-w-[350px] -mt-20 md:mt-0">
        <ForgotPasswordForm />
      </div>
    </div>
  );
};
